@reference "~/styles.css";

@layer components {
	.truncated {
		&:where(:has(.rightHalf)) {
			/*
			The grid defines 3 cols:
			1. Left half of the text that is not truncated, but breaks/hides if no space is available.
			2. Right half
			3. Spacer that pushes the right half to the left
			*/
			@apply grid grid-cols-[minmax(0,auto)_auto_1fr];
			/*
			The left half can break multiline, so the excess should be hidden
			*/
			@apply items-start max-h-lh overflow-clip break-all whitespace-normal;
			/*
			When the left half is multiline, it might have a trailing space.
			The space is small but noticeable, so justify stretches the text to cover it.
			*/
			@apply text-justify;

			&:where(.inline) {
				@apply inline-grid;
			}
		}

		&:where(:not(:has(.rightHalf))) {
			@apply block overflow-hidden text-ellipsis whitespace-nowrap;

			&:where(.inline) {
				@apply inline;
			}
		}
	}

	.rightHalf {
		@apply overflow-hidden text-ellipsis whitespace-nowrap text-left;

		&::before,
		&::after {
			/*
      Add &lrm; to the end to prevent punctuation from being at the start of the line.
      https://stackoverflow.com/a/42551367

      The before/after content cannot be copied so it is a perfect place to define it.
      */
			content: "\200E";
		}
	}
}
